import { ChangeEvent, ReactNode } from "react"
import { Dropdown, DropdownChangeParams } from "primereact/dropdown"
import { classNames } from "primereact/utils"
import styles from "./styles.module.css"
import commonStyles from "../../common.module.css"
import FieldError from "../../FieldError"
import { InputText } from "primereact/inputtext"
import { useInputTextMouseWheel } from "../../../common/useInputTextMouseWheel"
import { useConstants } from "../../../api/queries/useConstants"
import { Country } from "../../../api/types/constants"

export const PhoneInput = ({
  placeholder,
  prefix,
  value,
  onChange,
  isRequired,
  error,
}: PhoneInputProps) => {
  useInputTextMouseWheel()
  const { data: constants } = useConstants()

  const handlePrefixChange = (event: DropdownChangeParams): void => {
    onChange({ prefix: event.value, value })
  }

  const tPrefixItem = (country: Country): ReactNode => {
    return (
      <>
        <span className={`fi fi-${country.value.toLowerCase()}`} /> {country.prefix}
      </>
    )
  }

  const tPrefixValue = (country: Country): ReactNode => {
    return country
      ? tPrefixItem(country)
      : <span>&nbsp;</span>
  }

  const handleNumberChange = (event: ChangeEvent<HTMLInputElement>): void => {
    let value = event.target.value

    if (value === "") {
      onChange({ prefix, value: null })
    } else {
      let number = parseInt(value)
      if (!isNaN(number)) {
        onChange({ prefix, value: number })
      }
    }
  }

  return (
    <>
      <span className={`p-float-label ${styles.prefix}`}>
        <Dropdown options={constants?.results.countries || []} value={prefix}
          onChange={handlePrefixChange}
          optionLabel={"prefix"} optionValue={"prefix"}
          itemTemplate={tPrefixItem} valueTemplate={tPrefixValue}
          className={classNames({ "p-invalid": !!error })} />
        <label className={isRequired ? commonStyles.labelRequired : ""}>Předvolba:</label>
      </span>

      <span className={`p-float-label ${styles.number}`}>
        <InputText value={value || ""} onChange={handleNumberChange} type={"number"}
          className={classNames({ "p-invalid": !!error, [styles.numberInput]: true })}
          aria-autocomplete={"none"} />
        <label className={isRequired ? commonStyles.labelRequired : ""}>{placeholder}</label>
      </span>

      <FieldError error={error} />
    </>
  )
}

export interface PhoneInputProps {
  placeholder: string;
  prefix: string;
  value: number | null;
  onChange: ({ prefix, value }: { prefix: string, value: number | null }) => void;
  isRequired: boolean;
  error?: string;
}
